module.exports = "<div><div class=row><div class=col-md-8><h4>Short Profile</h4></div></div><div class=row><div class=col-md-12><p>{{ user.web_profile }}</p></div></div></div>";
